export default {
  placeholder: 'Select part',
};
